//-- Copyright (c) 2021 TMT Insights Group, LLC
// import { scan } from 'react-scan'; // must be imported before React and React DOM
import { rootElementId } from '@/constants/constants';
import { datadogRum } from '@datadog/browser-rum';
import { createRoot } from 'react-dom/client';
import ReactGA from 'react-ga4';
import { Provider } from 'react-redux';
// import kcConfig from '@/__configs/kc_media/configs';
import pbsConfig from '@/__configs/pbs/configs';
// import uniConfig from '@/__configs/univision/configs';
import { ClientConfig } from './__configs/config_types';
import App from './App';
import './index.scss';
import store from './redux/store';

if (window.location.hostname !== 'localhost') {
  datadogRum.init({
    applicationId: '261a160b-575e-458d-a07e-dc1d4aade9b2',
    clientToken: 'pubea5425eb0eb88a0e41ff1505b33fd8a1',
    site: 'datadoghq.com',
    service: 'oms-fe',
    env: 'dev',
    // Specify a version number to identify the deployed version of your application in Datadog
    // version: '1.0.0',
    sessionSampleRate: 100,
    sessionReplaySampleRate: 0,
    trackUserInteractions: true,
    trackResources: false,
    trackLongTasks: false,
    defaultPrivacyLevel: 'mask-user-input'
  });
  ReactGA.initialize('G-7CFHVKLPX5');
} else {
  // scan({ enabled: true });
}

const container = document.getElementById(rootElementId) as HTMLElement;
const root = createRoot(container);

const clientConfigs = {
  pbs: {
    config: pbsConfig,
    label: 'PBS'
  }
};

const configOptions = Object.keys(clientConfigs).map((key) => ({
  key,
  label: clientConfigs[key as keyof typeof clientConfigs].label
}));

const client = localStorage.getItem('client') || 'pbs';
const config = clientConfigs[client as keyof typeof clientConfigs]?.config || pbsConfig;

root.render(
  <Provider store={store}>
    <App config={config as ClientConfig} configOptions={configOptions} />
  </Provider>
);
